import { Input } from "../../ui/input";
import { Textarea } from "../../ui/textarea";
import { ArrowUp, ArrowDown, Trash2 } from "lucide-react";

export const HighlightEditor = ({ item, index, total, onChange, onMoveUp, onMoveDown, onRemove }) => (
  <div className="border rounded p-4 space-y-2" data-testid={`seo-highlight-item-${index}`}>
    <div className="flex items-center justify-between">
      <p className="text-xs text-muted-foreground uppercase tracking-wider">Beneficio {index + 1}</p>
      <div className="flex gap-2">
        <button data-testid={`seo-highlight-move-up-${index}`} onClick={onMoveUp} disabled={index === 0} className="disabled:opacity-30">
          <ArrowUp size={14} />
        </button>
        <button data-testid={`seo-highlight-move-down-${index}`} onClick={onMoveDown} disabled={index === total - 1} className="disabled:opacity-30">
          <ArrowDown size={14} />
        </button>
        <button data-testid={`seo-highlight-remove-${index}`} onClick={onRemove}>
          <Trash2 size={14} />
        </button>
      </div>
    </div>
    <Input
      data-testid={`seo-highlight-title-${index}`}
      value={item.title}
      onChange={(e) => onChange({ ...item, title: e.target.value })}
      placeholder="Título del beneficio"
    />
    <Textarea
      data-testid={`seo-highlight-description-${index}`}
      value={item.description}
      onChange={(e) => onChange({ ...item, description: e.target.value })}
      placeholder="Descripción del beneficio"
    />
  </div>
);
